export { NotesSection } from './NotesSection';
export { VitalsSection } from './VitalsSection';
